import React from 'react'
import PropTypes from 'prop-types'
import home_icon from "../../assets/fonts/home.svg"

import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ title, titleLink, subtitle, subtitleLink, extratitle, extratitleLink, currentTile, extrasubtitle, extrasubtitleLink }) => {
    return (

        <div className='breadcrumb'>
            <ul className='flex items-center'>
                {(title && title !== "") ? (
                    <li className='breadcrumb-item flex items-center '>
                        <Link to={titleLink}>
                            {title}
                        </Link>
                    </li>
                ) : null}
                {(extratitle && extratitle !== "") ? (
                    <li className='breadcrumb-item flex items-center'>
                        <svg className='mx-2' width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.42749 0.482422L4.44715 6.00011L0.42749 11.5178" stroke="#828282" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" />
                        </svg>

                        <Link to={extratitleLink} >
                            {extratitle}
                        </Link>
                    </li>
                ) : null}
                {(subtitle && subtitle !== "") ? (
                    <li className='breadcrumb-item flex items-center '>
                        <svg className='mx-2' width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.42749 0.482422L4.44715 6.00011L0.42749 11.5178" stroke="#828282" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" />
                        </svg>

                        <Link to={subtitleLink}>
                            {subtitle}
                        </Link> 
                    </li>
                ) : null}
                {(extrasubtitle && extrasubtitle !== "") ? (
                    <li className='breadcrumb-item flex items-center '>
                        <svg className='mx-2' width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.42749 0.482422L4.44715 6.00011L0.42749 11.5178" stroke="#828282" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" />
                        </svg>

                        <Link to={extrasubtitleLink}>
                            {extrasubtitle}
                        </Link>
                    </li>
                ) : null}
                <li className="breadcrumb-item flex items-center active">
                    <svg className='mx-2' width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.42749 0.482422L4.44715 6.00011L0.42749 11.5178" stroke="#828282" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" />
                    </svg>

                    {currentTile}
                </li>
            </ul>
            {/* <Breadcrumb>
                {(title && title !== "") ? (
                    <Breadcrumb.Item href={titleLink}>
                        {title}
                    </Breadcrumb.Item>
                ) : null}
                {(extratitle && extratitle !== "") ? (
                    <Breadcrumb.Item href={extratitleLink}>
                        {extratitle}
                    </Breadcrumb.Item>
                ) : null}
                {(subtitle && subtitle !== "") ? (
                    <Breadcrumb.Item href={subtitleLink}>
                        {subtitle}
                    </Breadcrumb.Item>
                ) : null}
                // added extrasubtitle and added extrasubtitleLink by latest branch 
                {(extrasubtitle && subtitle !== "") ? (
                    <Breadcrumb.Item href={extrasubtitleLink}>
                        {extrasubtitle}
                    </Breadcrumb.Item>
                ) : null}
                <Breadcrumb.Item active>
                    {currentTile}
                </Breadcrumb.Item>
            </Breadcrumb> */}
        </div>
    )
}
Breadcrumbs.propTypes = {
    title: PropTypes.object.isRequired,
    titleLink: PropTypes.string,
    subtitle: PropTypes.string,
    subtitleLink: PropTypes.string,
    extratitle: PropTypes.string,
    extratitleLink: PropTypes.string,
}
Breadcrumbs.defaultProps = {
    title: <img src={home_icon} alt="home icon" className="" />,
    titleLink: "",
    subtitle: "",
    subtitleLink: "",
    extratitle: "",
    extratitleLink: ""
}
export default Breadcrumbs
